import React from 'react';
import ImageGallerycommunitycenter from '../components/ImageGallerycommunitycenter';
import IRCTVDonationCard from "./IRCTVDonationCard";

const IRCCOMMUNITY = () => {
  // Function to handle phone number clicks
  const handlePhoneClick = (phoneNumber) => {
    // Remove any non-digit characters (like hyphens)
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    
    // Create the tel: link
    const telLink = `tel:${cleanedNumber}`;
    
    // Open the dialer (works on mobile devices)
    window.location.href = telLink;
  };

  return (
    <>
      <div className="about-us-container">
        {/* Detailed Activities Section */}
        <section className="activities-details">
           <button 
          onClick={() => window.history.back()}
          style={{
            marginBottom: '10px',
            padding: '8px 10px',
            backgroundColor: '#255fe8',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          ← Back to All Activities
        </button>

          <div className="about-us-container">
            {/* Detailed Activities Section */}
            <section className="activities-details">
         
              <div className="activity-intro">
                <h2>IRC COMMUNITY CENTRE (IRCCC)</h2>
                <p>At IRC Community Centre, our mission is to empower our community through accessible healthcare, education, and technical skills development. We are committed to providing a range of services that enhance the well-being and prospects of individuals and families in IRC Community Centre.</p>
              </div>
          <ImageGallerycommunitycenter />

              {/* IRC Community Centres */}
              <div className="activity-card">
                <div className="activity-header">
                  <h3>OUR COMMUNITY CENTRES</h3>
                </div>
                <div className="activity-content">
                  <div className="clinic-card">
                    <h4>Centre - 1 - Baijipura</h4>
                    <p><strong>Name:</strong> IRC Community Centre Baijipura</p>
                    <p><strong>Address:</strong> Galli No. 34 Main Road, Near Bin Rashed Masjid, Baijipura, Indira Nagar, Chhatrapati Sambhajinagar (Aurangabad), Maharashtra 431001</p>
                    <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Charitable+Clinic+Baijipura/@19.883,75.3481894,54m/data=!3m1!1e3!4m6!3m5!1s0x3bdb99869c8e3829:0xfe225775f9e4427b!8m2!3d19.8829763!4d75.3484207!16s%2Fg%2F11by_fl3hq?authuser=0&entry=ttu&g_ep=EgoyMDI2MDIxMS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                    <p><strong>Date of Inauguration:</strong> 20-May-2023</p>
                    <p><strong>Services Offered:</strong></p>
                    <ul>
                      <li>IRC Charitable Clinic</li>
                      <li>IRC Dental Clinic</li>
                      <li>IRC Women Empowerment Centre</li>
                      <li>IRC Technical Institute</li>
                    </ul>
                    <p>
                      <strong>Contact No: </strong>
                      <span 
                        className="contact-number" 
                        onClick={() => handlePhoneClick('80-5555-7732')}
                        style={{cursor: 'pointer', color: 'blue', textDecoration: 'underline'}}
                      >
                        80-5555-7732
                      </span>
                    </p>
                  </div>

                  {/* <div className="clinic-card">
                    <h4>Centre - 2 - Ambar Hill</h4>
                    <p><strong>Name:</strong> IRC Community Centre Ambar Hill</p>
                    <p><strong>Address:</strong> Gut No. 250, Plot No. 12 & 13, Jatwada Road, Beside Mohammadi Masjid, Ambar Hill, Chhatrapati Sambhajinagar (Aurangabad), Maharashtra 431008</p>
                    <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                    <p><strong>Date of Inauguration:</strong> 27-Jun-2023</p>
                    <p><strong>Services Offered:</strong></p>
                    <ul>
                      <li>IRC Charitable Clinic</li>
                      <li>IRC Women Empowerment Centre</li>
                      <li>IRC Free Water Supply</li>
                    </ul>
                    <p>
                      <strong>Contact No: </strong>
                      <span 
                        className="contact-number" 
                        onClick={() => handlePhoneClick('8507-8507-32')}
                        style={{cursor: 'pointer', color: 'blue', textDecoration: 'underline'}}
                      >
                        8507-8507-32
                      </span>
                    </p>
                  </div> */}

                  <div className="clinic-card">
                    <h4>Centre - 2 - Padegaon</h4>
                    <p><strong>Name:</strong> IRC Community Centre Padegaon</p>
                    <p><strong>Address:</strong> Masjid Hazrat Umar, Padegaon, Chhatrapati Sambhajinagar (Aurangabad), Maharashtra 431002</p>
                    <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Masjid+Hazrat+Umar/@19.8828442,75.282032,306m/data=!3m1!1e3!4m6!3m5!1s0x3bdb99005153be89:0x841f4eaaf92b8ecc!8m2!3d19.8834625!4d75.2818594!16s%2Fg%2F11zjm6h0dt?authuser=0&entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=44e5139e-9053-44e6-9e6b-37e564fc4f67" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                    <p><strong>Date of Inauguration:</strong> 07-Apr-2023</p>
                    <p><strong>Services Offered:</strong></p>
                    <ul>
                      <li>IRC Madarsa</li>
                      <li>IRC Women Empowerment Centre</li>
                      <li>IRC Free Water Supply</li>
                    </ul>
                    <p>
                      <strong>Contact No: </strong>
                      <span 
                        className="contact-number" 
                        onClick={() => handlePhoneClick('7537-9999-00')}
                        style={{cursor: 'pointer', color: 'blue', textDecoration: 'underline'}}
                      >
                        7537-9999-00
                      </span>
                    </p>
                  </div>

                  <div className="clinic-card">
                    <h4>Centre - 3 - Fazilpura</h4>
                    <p><strong>Name:</strong> IRC Community Centre Fazilpura</p>
                    <p><strong>Address:</strong> Plot No.21/Part, Fazalpura, St Colony, Shah Bazar, Chhatrapati Sambhajinagar (Aurangabad), Maharashtra 431001</p>
                    <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Community+Centre+Fazilpura/@19.8923648,75.337948,185m/data=!3m1!1e3!4m7!3m6!1s0x3bdb99b4f54ca53b:0x3d046e6607a361c8!8m2!3d19.8921593!4d75.3397455!15sCgNJUkOSARBjb21tdW5pdHlfY2VudGVy4AEA!16s%2Fg%2F11v3gyjqzs?authuser=0&entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=3bf0368a-db9d-4b61-8df6-034f02bac5fa" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                    <p><strong>Date of Inauguration:</strong> NA</p>
                    <p><strong>Services Offered:</strong></p>
                    <ul>
                      <li>Fahm-e-Quran Institute</li>
                      <li>The Ideal Muslimah</li>
                      <li>IRC Pharmacy</li>
                    </ul>
                    <p>
                      <strong>Contact No: </strong>
                      <span 
                        className="contact-number" 
                        onClick={() => handlePhoneClick('9607-052-142')}
                        style={{cursor: 'pointer', color: 'blue', textDecoration: 'underline'}}
                      >
                        9607-052-142
                      </span>
                    </p>
                  </div>

                  <div className="clinic-card">
                    <h4>Centre - 4 - Ibrahim Park</h4>
                    <p><strong>Name:</strong> IRC Community Centre Ibrahim Park</p>
                    <p><strong>Address:</strong> Gut No. 33, Ibrahim Park, Satara Parisar, Beed By Pass Road, Chhatrapati Sambhajinagar (Aurangabad)-431001.</p>
                     <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Community+Centre+Ibrahim+Park/@19.8515047,75.3068061,256m/data=!3m1!1e3!4m6!3m5!1s0x3bdb9939008d5771:0x78edc41cf90a24d5!8m2!3d19.8515497!4d75.3062471!16s%2Fg%2F11vsdq1xmd?entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=6ddb8c95-979f-4230-9c2e-1dab52a734c6" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                    <p><strong>Date of Inauguration:</strong> NA</p>
                    <p><strong>Services Offered:</strong></p>
                    <ul>
                      <li>IRC Madarsa</li>
                      <li>IRC Charitable Clinic</li>
                      <li>IRC Women Empowerment Centre</li>
                      <li>IRC Study Centre</li>
                      <li>IRC Free Water Supply</li>
                    </ul>
                    <p>
                      <strong>Contact No: </strong>
                      <span 
                        className="contact-number" 
                        onClick={() => handlePhoneClick('7537-9999-00')}
                        style={{cursor: 'pointer', color: 'blue', textDecoration: 'underline'}}
                      >
                        7537-9999-00
                      </span>
                    </p>
                  </div>

                  <div className="clinic-card">
                    <h4>Centre - 5 - Rohila Gali</h4>
                    <p><strong>Name:</strong> IRC Community Centre Rohila Gali</p>
                    <p><strong>Address:</strong> # 1-23-94 Rohila Gali Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                    <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Masjid+Ikhlas/@19.8909525,75.3303293,76m/data=!3m1!1e3!4m6!3m5!1s0x3bdb99588c76a00f:0xcf1c49b4ae78975!8m2!3d19.8909467!4d75.330867!16s%2Fg%2F11vjm4_dll?authuser=0&entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=0c44c213-ab7e-4e64-90c9-de6e69bc03f3" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                    <p><strong>Date of Inauguration:</strong> NA</p>
                    <p><strong>Services Offered:</strong></p>
                    <ul>
                      <li>IRC DASTARKHWAN (FOOD FOR POOR & NEEDY)</li>
                      <li>IRC Free Water Supply</li>
                      <li>IRC Charitable Clinic</li>
                      <li>IRC Women Empowerment Centre</li>
                      <li>IRC Technical Institute</li>
                      <li>IRC Minority Development Center</li>
                      <li>IRC Madarsa</li>
                      <li>IRC Arabic Academy</li>
                    </ul>
                  </div>
                </div>
                   <IRCTVDonationCard 
               title="OUR COMMUNITY CENTRES"
              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality content and services to our community."
              amount="₹5000"
              purpose="Cause: OUR COMMUNITY CENTRES"
            />
              </div>
            </section>
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCCOMMUNITY;